import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchConvoForParticipantNotification = createAction(constants.FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION)

export const subscribed = createAction(constants.FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION)

export const serviceWorkerRegistered = createAction(constants.SW_REGISTRATION_SUCCESS)
export const failedToRegisterServiceWorker = createAction(constants.SW_REGISTRATION_FAILED)

export const serviceWorkerMessage = createAction(constants.SERVICE_WORKER_MESSAGE)

export const soundPlayed = createAction(constants.NOTIFICATION_SOUND_SUCCESS)
export const soundPlayFailed = createAction(constants.NOTIFICATION_SOUND_FAILED)

export const showAbmModal = createAction(constants.SHOW_ABM_MODAL)
export const showAbmModalFailed = createAction(constants.SHOW_ABM_MODAL_FAILED)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/notification/actions.js